// extracted by mini-css-extract-plugin
module.exports = {"title":"lost-connection_title__GHx3d","footerText":"lost-connection_footerText__3W8_W","container":"lost-connection_container__3e1RP"};